import React from 'react';
import { Link } from 'react-router-dom';

export default function EventoCard({ evento }) {
    return (
        <div className="col-sm-6 col-md-4 col-lg-4">
            <div className="event-grid">
                <div className="movie-thumb c-thumb">
                    <Link to={{ pathname: `/evento/${evento.id}/` }}>
                        <img src={'/assets/images_mt/eventos/home/' + evento.website_imagen} alt={evento.nombre} />
                    </Link>
                </div>
                <div className="movie-content bg-one">
                    <h5 className="title m-0">
                        <Link to={{ pathname: `/evento/${evento.id}/` }}>{evento.nombre}</Link>
                        <br /><small>{evento.descripcion}</small>
                    </h5>
                    <div className="movie-rating-percent">
                        <span>{evento.horario_texto}<br />{evento.foro_nombre}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}
